const getFormattedNumber = (number) => {
    if (typeof number !== 'number') {
        return;
    }
    
        return (number.toFixed(2) * 1).toLocaleString();
};

export { getFormattedNumber };
